export const CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE = 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE';
export const CUSTOM_WITHOUT_SRP = 'CUSTOM_WITHOUT_SRP';
